import * as actions from './actions';

import { ActionType, createReducer } from 'typesafe-actions';

import { ACTION_STATUSES } from 'shared/consts/consts';
import { QrCodeState } from './types';

export const INITIAL_STATE: QrCodeState = {
  qrCodes: {},
  getQrCode: {
    status: null,
    error: null,
  },
};

const getQrCodeRequestHandler = (state: QrCodeState): QrCodeState => ({
  ...state,
  getQrCode: {
    status: ACTION_STATUSES.PENDING,
    error: null,
  },
});

const getQrCodeSuccessHandler = (
  state: QrCodeState,
  { payload }: ActionType<typeof actions.getQrCode.success>,
): QrCodeState => ({
  ...state,
  qrCodes: {
    ...state.qrCodes,
    [payload.content]: payload.svg,
  },
  getQrCode: {
    status: ACTION_STATUSES.FULFILLED,
    error: null,
  },
});

const getQrCodeFailureHandler = (
  state: QrCodeState,
  { payload }: ActionType<typeof actions.getQrCode.failure>,
): QrCodeState => ({
  ...state,
  getQrCode: {
    status: ACTION_STATUSES.REJECTED,
    error: payload.error,
  },
});

const clearQrCodeHandler = (state: QrCodeState, { payload }: ActionType<typeof actions.clearQrCode>): QrCodeState => ({
  ...state,
  qrCodes: {
    ...state.qrCodes,
    [payload]: undefined,
  },
  getQrCode: {
    status: null,
    error: null,
  },
});

const QrCodeReducer = createReducer(INITIAL_STATE)
  .handleAction(actions.getQrCode.request, getQrCodeRequestHandler)
  .handleAction(actions.getQrCode.success, getQrCodeSuccessHandler)
  .handleAction(actions.getQrCode.failure, getQrCodeFailureHandler)
  .handleAction(actions.clearQrCode, clearQrCodeHandler);

export default QrCodeReducer;
